import {
  PROPERTIES_REQUEST,
  PROPERTIES_REQUEST_SUCCESS,
  PROPERTIES_REQUEST_FAILED,
  PROPERTY_DETAILS_REQUEST,
  PROPERTY_DETAILS_REQUEST_SUCCESS,
  PropertiesState,
  PROPERTY_DETAILS_REQUEST_FAILED,
} from '../types/properties';
import { PropertiesActionsTypes } from '../actions/properties';

const initialState: PropertiesState = {
  items: [],
  total: 0,
  error: '',
  loading: false,
  selected: null,
};

export default function (
  state = initialState,
  action: PropertiesActionsTypes,
): PropertiesState {
  switch (action.type) {
    case PROPERTY_DETAILS_REQUEST:
    case PROPERTIES_REQUEST: {
      return {
        ...state,
        error: '',
        loading: true,
      };
    }

    case PROPERTIES_REQUEST_SUCCESS: {
      return {
        ...state,
        items: action.payload.items,
        total: action.payload.total,
        error: '',
        loading: false,
      };
    }

    case PROPERTY_DETAILS_REQUEST_SUCCESS: {
      return {
        ...state,
        error: '',
        selected: action.payload,
        loading: false,
      };
    }

    case PROPERTY_DETAILS_REQUEST_FAILED:
    case PROPERTIES_REQUEST_FAILED: {
      return {
        ...state,
        error: action.payload.message,
        loading: false,
      };
    }

    default: {
      return state;
    }
  }
}
